import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input } from 'formik-antd';
import { Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { Button, Col, Row, Typography } from 'antd';
import cx from 'classnames';

import BaseAlert from 'components/wrappers/BaseAlert';
import SubmitButton from 'components/formik/SubmitButton';
import FormItem from 'components/formik/FormItem';
import { forgotPassword } from 'redux/reducers/authenticationSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

import logo from 'assets/img/logo-dark.svg';

import style from '../AuthorizationPage.module.less';

interface FormValues {
  email: string;
}

const validationSchema = Yup.object({
  email: Yup.string()
    .required('Field is required')
    .email('Email format is invalid')
    .max(120, 'Email should be 120 characters maximum'),
});

const { Title } = Typography;

export default function ForgotPasswordPage() {
  const [isForgotMode, setIsForgotMode] = useState(true);
  const dispatch = useAppDispatch();

  const handleSubmit = async (
    values: FormValues,
    formikHelpers: FormikHelpers<FormValues>,
  ) => {
    const result = await dispatch(forgotPassword(values.email));

    if (forgotPassword.fulfilled.match(result)) {
      setIsForgotMode(false);
    } else {
      BaseAlert.error(
        result.error.message || 'Something went wrong. Please try again.',
      );
    }
  };

  return (
    <div className={cx('scroll-box', style.authPage)}>
      <Row justify="end" className={style.fullHeight}>
        <Col xl={14}>
          <div className={style.authPageBg} />
        </Col>
        <Col xs={24} xl={10}>
          {isForgotMode && (
            <Formik
              initialValues={{ email: '' }}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              <Form
                className={cx(style.authPageForm, style.signInForm)}
                layout="vertical"
              >
                <div className={style.authPageTitle}>
                  <div>
                    Reset password
                    <div className={cx(style.authPageLogo, style.pageLogo)}>
                      <img src={logo} alt="myBasePay" />
                    </div>
                  </div>
                </div>
                <div className={style.authPageContent}>
                  <FormItem
                    data-id="forgotPasswordEmailField"
                    name="email"
                    label="Email address"
                  >
                    <Input size="large" name="email" autoComplete="off" />
                  </FormItem>
                  <Row>
                    <Col xs={24} md={10}>
                      <SubmitButton
                        data-id="resetPasswordBtn"
                        type="primary"
                        size="large"
                        block
                      >
                        Reset password
                      </SubmitButton>
                    </Col>
                  </Row>
                </div>
              </Form>
            </Formik>
          )}
          {!isForgotMode && (
            <div className={style.forgotMsg} data-id="reset-password-success">
              <span className="icon icon-check-filled" />
              <Title level={1}>Thank you</Title>
              <p className={style.forgotText}>
                We have sent password reset instructions to your email address.
                If no email is received, please try again.
              </p>
              <div className={style.forgotBtn}>
                <Link data-id="forgotPasswordLoginLink" to="/login">
                  <Button type="primary" size="large" block>
                    Log in
                  </Button>
                </Link>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
